/** Token colore per `app-icon` — mappa su variabili CSS del design system. */
export type IconColor = 'dark-blue' | 'dark-red' | 'dark-grey' | 'black';

export const ICON_COLOR_MAP: Record<IconColor, string> = {
  'dark-blue': 'var(--dark-blue)',
  'dark-red': 'var(--dark-red)',
  'dark-grey': 'var(--dark-grey)',
  'black': 'var(--black)',
};

/** Restituisce il valore CSS o `null` per lasciare `color: inherit` sul componente. */
export function resolveIconColor(color: IconColor | null | undefined): string | null {
  if (!color) {
    return null;
  }
  return ICON_COLOR_MAP[color] ?? null;
}
